import { useQuery } from 'react-query';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';
import {
  IFlattenServerErrorResponse,
  IServerErrorResponse,
} from '../../../types';
import { flattenServerErrorResponse } from '../../../helpers/errors.helper';

export interface GetVendorDetailsRequestResponse {
  businessName: string;
  billNumber: string;
}

interface GetVendorDetailsRequestProps {
  token: string;
  onError: (error: IFlattenServerErrorResponse) => void;
  onSuccess: (response: GetVendorDetailsRequestResponse) => void;
}

export const useGetVendorDetailsRequest = ({
  token,
  onError,
  onSuccess,
}: GetVendorDetailsRequestProps) => useQuery(
  'useGetVendorDetailsRequest',
  async () => {
    const res = await httpService.get(
      `${BASE_URL}//api/v1/public/bill?token=${token}`,
    );
    return res.data as GetVendorDetailsRequestResponse;
  },
  {
    refetchOnWindowFocus: false,
    retry: 0,
    enabled: true,
    staleTime: 0,
    cacheTime: 0,
    onError: (e: IServerErrorResponse) => onError(flattenServerErrorResponse(e)),
    onSuccess,
  },
);
